import * as THREE from 'three'
import TimeManager from '../Utils/TimeManager'
import {ChangeStateEvent, HoverPath} from '../../script'
import { Vector2 } from 'three'

export default class TouchDetect
{
    constructor(scene, data)
    {
        this.scene = scene

        this.data = data

        this.raycaster = new THREE.Raycaster()

        this.objectsToTest = []

        this.mouse = new THREE.Vector2()

        this.time = new TimeManager()

        this.intersectingObject = null
        this.intersectingNode = null

        this.cancelMouse = false
        this.mousePosDown = null
        
        // subscribe to update
        this.scene.time.on('tick', () =>
        {
            this.shootRay()
        })

        window.addEventListener('mousemove', (event) =>
        {
            this.mouse.x = event.clientX / this.scene.sizes.width * 2 - 1
            this.mouse.y = - (event.clientY / this.scene.sizes.height) * 2 + 1
        })

        window.addEventListener('pointerdown', (event) =>
        {
            this.mouse.x = event.clientX / this.scene.sizes.width * 2 - 1
            this.mouse.y = - (event.clientY / this.scene.sizes.height) * 2 + 1
            this.mousePosDown = new Vector2(event.clientX, event.clientY)
        })

        window.addEventListener('pointerup', (event) =>
        {
            const mousePos = new Vector2(event.clientX,event.clientY)
            const mouseDelta = this.mousePosDown.distanceTo(mousePos)
            if (mouseDelta < 2) {
                this.intersectingNode = this.findIntersectNode(this.intersectingObject)
                ChangeStateEvent(this.intersectingNode)
            } else this.cancelMouse = false
        })
    }

    addToRaycast(node) {
        for( var i = 0; i < this.objectsToTest.length; i++){ 
            if ( this.objectsToTest[i].id === node.threeObject.id) { 
                return
            }
        }
        this.objectsToTest.push(node.threeObject)
    }

    removeFromRaycast(node) {
        for( var i = 0; i < this.objectsToTest.length; i++){ 
            if ( this.objectsToTest[i].id === node.threeObject.id) { 
                this.objectsToTest.splice(i, 1); 
                console.log("removed " + node);
            }
        }
    }

    shootRay() {
        this.raycaster.setFromCamera(this.mouse, this.scene.camera)

        const intersects = this.raycaster.intersectObjects(this.objectsToTest, false)

        if (intersects.length > 0) {
            this.intersectingObject = intersects[0] 
            const node = this.findIntersectNode(this.intersectingObject)
            HoverPath(node)
            document.body.classList.add("cursor-hover");
        }
        else {
            this.intersectingObject = null
            HoverPath(null)
            document.body.classList.remove("cursor-hover");
        }
    }

    findIntersectNode(intersection) {
        if (!intersection) return null
        for (let index = 0; index < this.data.offchainNodes.length; index++) {
            if (intersection.object.id == this.data.offchainNodes[index].threeObject.id) return this.data.offchainNodes[index]
        }
        for (let index = 0; index < this.data.clientNodes.length; index++) {
            if (intersection.object.id == this.data.clientNodes[index].threeObject.id) return this.data.clientNodes[index]
        }
        for (let index = 0; index < this.data.blockChainNodes.length; index++) {
            if (intersection.object.id == this.data.blockChainNodes[index].threeObject.id) return this.data.blockChainNodes[index]
        }
        for (let index = 0; index < this.data.majorDappNodes.length; index++) {
            if (intersection.object.id == this.data.majorDappNodes[index].threeObject.id) return this.data.majorDappNodes[index]
        }
        return null
    }
}